import { combineReducers } from 'redux';

import auth from './auth';
import buttonReducer from './buttonReducer';

const reducers = combineReducers({ auth, button : buttonReducer });

export type RootState = ReturnType<typeof reducers>;

export default reducers;